// extracted by mini-css-extract-plugin
export default {"addressCard":"addressCardComponent_addressCard__Vulto","addressCardInfo":"addressCardComponent_addressCardInfo__RbkBT"};